import { createActions } from 'reduxsauce';
const { Types, Creators } = createActions({
  getListRITMTicket: ['params'],
  getListRITMTicketSuccess: ['dataRITMInit'],
  getListRITMTicketFail: [],
  getMoreListRITM: ['params'],
  getMoreListRITMSuccess: ['dataMoreRITM'],
  getMoreListRITMFail: [],
  searchRITMTicket: ['params'],
  searchRITMTicketSuccess: ['dataSearchRITM'],
  searchRITMTicketFail: [],
  getMoreListRITMWithSearch: ['params'],
  getMoreListRITMSuccessWithSearch: ['dataMoreRITM'],
  getMoreListRITMWithSearchFail: [],
});
export const TicketRITMTypes = Types;
export default Creators;
